import { render, staticRenderFns } from "./monitorRe.vue?vue&type=template&id=871dc698&scoped=true&"
import script from "./monitorRe.vue?vue&type=script&lang=js&"
export * from "./monitorRe.vue?vue&type=script&lang=js&"
import style0 from "./monitorRe.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./monitorRe.vue?vue&type=style&index=1&id=871dc698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871dc698",
  null
  
)

export default component.exports